import React from 'react';
import { translate } from 'react-i18next';

import BaseLayout from '../../components/Layout/BaseLayout';
import {HtmlEn} from './html';

const CommunityGuideline = props => {
    return (
        <BaseLayout history={props.history} match={props.match} landingUrl={props.landingUrl}>
            <div className="community-guideline">
                <HtmlEn />
            </div>
        </BaseLayout>
    );
};

export default translate()(CommunityGuideline);